import { HotspotPinComponentRenderer } from '@lessonup/pin-renderer';
import { HotspotPinComponent } from '@lessonup/pins-shared';
import { colorSets, styled } from '@lessonup/ui-components';
import React from 'react';
import { useSelectable } from '../../../../../hooks/useSelectable';

interface HotspotPinComponentRealtimePlayerProps {
  pinId: string;
  pinComponent: HotspotPinComponent;
  active: boolean;
}

export const HotspotPinComponentRealtimePlayer: React.FC<HotspotPinComponentRealtimePlayerProps> = ({
  pinId,
  pinComponent,
  active,
}) => {
  const { isSelected, isSelectedByOthers, handleSelect, ref } = useSelectable('pinComponent', pinComponent.id);

  const getShadowColor = () => {
    if (isSelected) return colorSets.active.on;
    if (isSelectedByOthers) return colorSets.active.on;
    return undefined;
  };

  return (
    <StyledHotspotWrapper
      ref={ref}
      onClick={handleSelect}
      style={{
        boxShadow: getShadowColor() ? `0 0 0 2px ${getShadowColor()}` : undefined,
      }}
    >
      <HotspotPinComponentRenderer pinId={pinId} pinComponent={pinComponent} active={active} />
    </StyledHotspotWrapper>
  );
};

const StyledHotspotWrapper = styled.div`
  border-radius: 100%;
  height: inherit;
  width: inherit;
  box-sizing: border-box;
  cursor: pointer;
  :hover {
    box-shadow: 0 0 0 2px ${colorSets.active.stroke};
  }
`;
